import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

if ($('.js-stats-block').length) {
    const $statsBlockSlider = $('.js-stats-block');

    $statsBlockSlider.each(function () {
        const $slider = $(this)[0];

        const statsBlockSlider = new Swiper($slider, {
            autoplay: {
                delay: 5000,
                enabled: false,
            },
            loop: true,
            modules: [Autoplay, Pagination],
            pagination: {
                clickable: true,
                el: '.swiper-pagination',
            },
            slidesPerGroup: 1,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerGroup: 2,
                    slidesPerView: 2,
                },
            },
        });
    });
}

if ($('.js-team-slider').length) {
    const $teamSlider = $('.js-team-slider');

    $teamSlider.each(function () {
        const $slider = $(this)[0];

        const teamSlider = new Swiper($slider, {
            autoHeight: true,
            loop: true,
            modules: [Pagination],
            pagination: {
                clickable: true,
                el: '.swiper-pagination',
            },
            slidesPerGroup: 1,
            slidesPerView: 1,
        });

        $slider.querySelectorAll('details').forEach(function (details) {
            details.addEventListener('toggle', function () {
                var start = performance.now();

                function syncHeight(timestamp) {
                    teamSlider.updateAutoHeight(0);

                    if (timestamp - start < 300) {
                        requestAnimationFrame(syncHeight);
                    }
                }

                requestAnimationFrame(syncHeight);
            });
        });
    });
}
